$ = require 'jquery'
l = require 'lib/localize'
getExperiment = require 'lib/experiments/simple-test'
React = require 'react'
t = require('views/internal/recup-with-helpers')('header_experiment_menu')
Util = require 'lib/util'
_ = require 'underscore'
audienceDefinitions = require 'lib/experiments/audience-definitions'

class HeaderExperimentDetails extends React.Component
  displayName: 'HeaderExperimentDetails'
  _cookieName: ->
    "force_#{@props.experimentName}"

  onVariationOverride: (e, variationName) ->
    Util.stop(e)

    $.cookie(@_cookieName(), variationName, { path: '/', expires: 30 })
    document.location.reload()

  onVariationRemove: (e) ->
    Util.stop(e)

    $.cookie(@_cookieName(), null, { path: '/', expires: -1 })
    document.location.reload()

  render: t.renderable ->
    { experimentName } = @props

    experimentAttrs = getExperiment(experimentName)
    activeVariation = experimentAttrs.get('variation')
    config = window.abTests[experimentName]

    variations = [
      {
        name: 'control'
        weight: config.defaultWeight
      }
    ]

    config.variations.forEach (variation) ->
      variations.push({
        name: variation.name
        weight: variation.weight
      })

    totalWeight = _.chain(variations)
    .map (variation) -> variation.weight
    .reduce ((sum, v) -> sum + v), 0
    .value()

    variations.forEach (entry) ->
      entry.active = entry.name == activeVariation
      entry.percentage = Math.round(10000 * entry.weight / totalWeight) / 100


    foundAudience = false
    allocations = config.audiences.map (audience) ->
      # Simple Test uses the first audience that the member
      # is in
      inAudience = audienceDefinitions[audience]?(config.audienceSettings)
      used = !foundAudience && inAudience
      foundAudience = foundAudience || inAudience

      {
        audience: audience
        allocation:
          if _.isObject(config.experimentAllocation)
            config.experimentAllocation[audience] ? 0
          else
            config.experimentAllocation
        used: used
      }

    t.div '.header-experiment-config', =>
      t.h3 -> t.format 'experiment-name'
      t.p -> t.text experimentName
      if config.meta?
        t.h3 -> t.format 'description'
      if config.meta?.image
        t.p ->
          t.a {
            href: config.meta.image
            target: '_blank'
            rel: 'noopener noreferrer'
          }, ->
            t.img '.header-experiment-image', {
              src: config.meta.image
              alt: ''
            }
      if config.meta?.description
        t.p -> t.text config.meta.description
      if config.meta?.link
        t.p -> t.a {
          href: config.meta.link
          target: '_blank'
          rel: 'noopener noreferrer'
        }, ->
          t.text config.meta.link
      t.h3 -> t.format 'current-active-variation'
      t.p -> t.text activeVariation
      t.h3 -> t.format 'experiment-allocation'
      t.p ->
        t.ul ->
          for { audience, allocation, used } in allocations
            t.li ->
              t.text "#{audience}: #{allocation * 100}%"
              if used
                t.text ' '
                t.icon 'check'
      if config.audienceSettings
        t.h3 -> t.format 'audience-settings'
        t.p ->
          t.ul ->
            for key in Object.keys(config.audienceSettings)
              t.li ->
                t.text "#{key}: #{config.audienceSettings[key]}"
      t.h3 -> t.format 'variation-allocation'
      t.ul ->
        variations.map ({ name, percentage }) ->
          t.li -> t.text "#{name}: (#{percentage}%)"
      t.hr()
      t.h3 -> t.format 'override-variation'
      t.p -> t.format 'override-variation-note'
      t.ul '.header-experiment-overrides', =>
        variations.map ({ active, name }) =>
          t.li => t.button {
            class: t.classify({
              primary: true
              'button-link': true
              disabled: active
            })
            disabled: active
            onClick: (e) => @onVariationOverride(e, name)
          }, ->
            t.text name
            if active
              t.text ' '
              t.icon 'check'
      t.hr()
      t.h3 -> t.format 'remove-experiment-cookie'
      t.p -> t.format 'remove-experiment-cookie-note'
      t.button {
        class: t.classify({
          negate: true
          'button-link': true,
          'header-experiment-remove-btn': true
        })
        onClick: (e) => @onVariationRemove(e)
      }, ->
        t.format 'remove-experiment-cookie'

module.exports = HeaderExperimentDetails



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-experiment-details.coffee